<template>
  <div class="inquery">
    <div class="box">
      <div class="logo" @click="goHome">
        <h1>北京佰标技术服务中心</h1>
      </div>
      <div class="formin">
        <div class="title">
            <div class="cname">{{ titleName }}</div>
            <div class="more">
              <span>证书查询</span>
              <span class="button" @click="showColumn"></span>
            </div>
        </div>
        <div class="info">
          <span class="cnamep">{{ cnameplaceholder }}</span>
          <input type="text" v-model="cname" name="cname" :placeholder="'请输入'+cnameplaceholder" class="cname">
          <span class="ccodep">{{ ccodeplaceholder }}</span>
          <input type="text" v-model="ccode" name="cname" :placeholder="'请输入' + ccodeplaceholder" class="ccode">
          <span class="bzcodep">{{bzcodeplaceholder}}</span>
          <input type="text" v-model="bzcode" name="bzcode" :placeholder="'请输入' + bzcodeplaceholder" class="bzcode">
          <input type="button" value="查询" @click="query" class="inq">
        </div>
      </div>
      <div class="copyright">©CopyRight 2002-2020 版权所有</div>
    </div>
   <transition name="fade">
    <div class="showcolumn" @click="showColumn" v-show="showcolumn">
      <ul class="column">
          <li class="title">查询栏目</li>
          <li v-for="item in column"
           :class="selectid == item.id&&'select'"
            @click="handleColumn(item.id)"
            :key ="item.id"
            >{{item.name}}</li>
      </ul>
    </div>
    </transition>
    <div class="code-select" v-show="occupationFlag">
      <el-dialog title="请选择职业名称" width="90%" :visible.sync="occupationFlag">
        <el-form :model="form">
          <el-form-item label="职业名称">
            <el-select v-model="form.certname" placeholder="请选择职业名称">
              <el-option v-for="(cet,index) in occupations" :key="index" :label="cet.certname" :value="cet.certname">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="occupationFlag = false">取 消</el-button>
          <el-button type="primary" @click="handleInq()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
/**
 * 
查询栏目  1、企业证书查询系统 （单位名称+信用代码+证书编号）
2、企业荣誉查询系统 （单位名称+信用代码+证书编号）
3、企业牌匾查询系统 （单位名称+信用代码+证书编号）
3、主编单位查询系统 （单位名称+信用代码+标准号）
4、参编单位查询系统  （单位名称+信用代码+标准号）
（主办单位和参编单位公用一个查询模块即可）
5、主编人员查询系统   （姓名+身份证号+证书编号）
6、参编人员查询系统  （姓名+身份证号+证书编号）
（主办人员和参编人员公用一个查询模块即可）
 */
import { certificateCBDW, certificateQYPB, certificateQYRY, certificateQYZS, certificateCBRY, certificateZBRY, certificateZBDW } from '@/request/index';
export default {
  metaInfo: {
    title: '北京佰标技术服务中心',
    meta: [
      {
        name: 'viewport', content:
          `width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0,minimal-ui:ios`
      }
    ]
  },
  name: "inqueryM",
  filters: {
    placeholderFilter(value) {
      return "请输入" + value
    }
  },
  components: {
  },
  data() {
    return {
      occupations: [],
      form: {
        certname: "",
      },
      occupationFlag: false,
      showcolumn:false,
      cname: "",
      ccode: "",
      bzcode: "",
      cnameplaceholder:"单位名称",
      ccodeplaceholder:"信用代码",
      bzcodeplaceholder:"证书编号",
      titleName: "企业证书查询系统",
      selectid:0,
      column: [{
        id: 0,
        name: "企业证书查询系统",
        cname: "单位名称",
        ccode: "信用代码",
        bzcode: "证书编号",
        func: certificateQYZS
      }, {
        id: 1,
        name: "主编单位查询系统",
        cname: "单位名称",
        ccode: "信用代码",
        bzcode: "标准号",
        func: certificateZBDW
      }, {
        id: 2,
        name: "参编单位查询系统",
        cname: "单位名称",
        ccode: "信用代码",
        bzcode: "标准号",
        func: certificateCBDW
      }, {
        id: 3,
        name: "主编人员查询系统",
        cname: "姓名",
        ccode: "身份证号",
        bzcode: "证书编号",
        func: certificateZBRY
      }, {
        id: 4,
        name: "参编人员查询系统",
        cname: "姓名",
        ccode: "身份证号",
        bzcode: "证书编号",
        func: certificateCBRY
      }, {
        id: 5,
        name: "企业荣誉查询系统",
        cname: "单位名称",
        ccode: "信用代码",
        bzcode: "证书编号",
        func: certificateQYRY
      }, {
        id: 6,
        name: "企业牌匾查询系统",
        cname: "单位名称",
        ccode: "信用代码",
        bzcode: "证书编号",
        func: certificateQYPB
      }]
    }
  },
  mounted() {
    var lastTouchEnd = 0;
    document.addEventListener(
      "touchend",
      function (event) {
        var now = new Date().getTime();
        if (now - lastTouchEnd <= 300) {
          event.preventDefault();
        }
        lastTouchEnd = now;
      },
      false
    );
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    showColumn() {
      this.showcolumn = !this.showcolumn;
    },
    handleColumn(index) {
      let item = this.column[index];
      this.cnameplaceholder = item.cname;
      this.ccodeplaceholder = item.ccode;
      this.bzcodeplaceholder = item.bzcode;
      this.titleName = item.name;
      this.selectid = item.id;
    },
    handleInq() {
      if (!this.form.certname) {
        this.$message.error("请选择职业名称");
        return;
      }
      this.$router.push({
        name: "Show",
        query: {
          cname: this.cname,
          ccode: this.ccode,
          bzcode: this.bzcode,
          selectid: this.selectid,
          certname: this.form.certname
        }
      })
    },
    /**
     *  cname: "单位名称"或姓名,
        ccode: "信用代码"或证件号,
        bzcode: "证书编号"或标准号
    */
    async query() {
      if (this.cname == "" && this.ccode == ""
        || this.cname == "" && this.bzcode == ""
        || this.ccode == "" && this.bzcode == "") {
        return;
      }
      let result = await this.column[this.selectid].func(this.bzcode, this.cname, this.ccode);
      if (result.success && result.data.length===1) {
        this.form.certname = result.data[0].certname;
        this.handleInq();
        return;
      }
      if (result.success && result.data.length) {
        this.occupations = result.data || [];
        this.occupationFlag = true;
      } else {
        this.$message.error("无法查询到信息，请确认信息是否填写正确！");
      }
    }
  }
};
</script>
<style scoped>
.inquery{
  position: relative;
  width: 100vw;
  height: 177.866667vw;
  background: url(/static/img/inq/h5/ios/bg_bjingH5@3x.png) no-repeat;
  background-size:100vw 177.866667vw;
  box-sizing: border-box;
}
.inquery>.box{
  position: relative;
  width: 93.6vw;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  overflow: hidden;
}
.inquery>.showcolumn{
  position: absolute;
  top:0;
  left:0;
  width: 100vw;
  height: 177.866667vw;
  z-index: 9;
  display: flex;
  justify-content: start;
}
.inquery>.showcolumn::before{
  content: '';
  flex:1;
  background: #000000;
  opacity: 0.6;
}
.inquery>.showcolumn>.column{
  position: relative;
  width: 78.2666667vw;
  height: 177.866667vw;
  opacity: 1;
  background: #FFFFFF url(/static/img/inq/h5/ios/ta@3x.png) no-repeat;
  background-size: 77.8666667vw 44.9333vw;
  background-position: center bottom;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  overflow: hidden;
}
.inquery>.showcolumn>.column>li{
  position: relative;
  width: 100%;
  height: 16vw;
  font-size: 4.2666vw;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 16vw;
  text-align: center;
}
.inquery>.showcolumn>.column>.title{
  height: 17.0666667vw;
  font-size: 5.86666667vw;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 17.0666667vw;
  border-bottom: 0.26666667vw solid #EFF0F1;
}
.inquery>.showcolumn>.column>.title::after{
  content: '';
  position: absolute;
  top: 6vw;
  right: 21.3333333vw;
  width: 1.86666667vw;
  height: 4.4vw;
  background: url(/static/img/inq/h5/ios/icon_chaxunyou@3x.png) no-repeat;
  background-size: 1.86666667vw 4.4vw;
}
.inquery>.showcolumn>.column>.title::before {
  content: '';
  position: absolute;
  top: 6vw;
  left: 20.8vw;
  width: 1.86666667vw;
  height: 4.4vw;
  background: url(/static/img/inq/h5/ios/icon_chaxunzuo@3x.png) no-repeat;
  background-size: 1.86666667vw 4.4vw;
}
.inquery>.showcolumn>.column>li.select{
  color: #2372BA;
}
.box>.logo{
  position: relative;
  margin-top:5.466vw;
  width: 55vw;
  background: url(/static/img/icon_logo.png) no-repeat;
  background-size: 55vw 30.6vw;
    height: 31vw;
  overflow: hidden;
}
.box>.logo>h1{
  position: absolute;
  left:-1116px;
}
.box>.formin{
  position: relative;
  margin-top: 8.8vw;
  width: 93.6vw;
  height: 114.2666vw;
  display: flex;
  flex-direction:column;
  justify-content: start;
  align-items: center;
  background-image: linear-gradient(to bottom, RGBA(214, 231, 248, .2), RGBA(121, 171, 247, .5));
}
.box>.formin>.title {
  width: 93.6vw;
  height: 10.666vw;
  display: flex;
  justify-content: start;
  font-size: 4.8vw;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 10.666vw;
  background: url(/static/img/inq/h5/ios/icon_zhegnshuchauxn@3x.png) no-repeat;
  background-size: 44.4vw 10.666vw;
  background-position: right center;
}
.box>.formin>.title>.cname{
  width: 59.7333333vw;
  height: 10.6666667vw;
  padding-left: 4.4vw;
  background: url(/static/img/inq/h5/ios/danwei_chaxun@3x.png) no-repeat;
  background-size: 59.7333333vw 10.6666667vw;
}
.box>.formin>.title>.more {
  width: 33.8666vw;
  height: 10.666vw;
  padding-left: 4.8vw; 
  font-size: 4vw;
  color: #3075ED;
  display: flex;
  justify-content: start;
  align-items: center;

}
.box>.formin>.title>.more>.button {
  margin-left: 3.2vw;
  width: 4.4vw;
  height: 3.4666vw;
  background: url(/static/img/inq/h5/ios/icon_shaixun@3x.png) no-repeat;
  background-size: 4.4vw 3.4666vw;
}
.box>.formin>.info{
  position: relative;
  width: 90.1333vw;
  height: 103.6vw;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
}
.box>.formin>.info>span{
  padding-left: 1.333333vw;
  height: 3.7333vw;
  font-size: 3.7333vw;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 3.7333vw;
}
.box>.formin>.info>span.cnamep{
  margin-top: 9.466666vw;
}
.box>.formin>.info>span.ccodep {
  margin-top: 6.666666vw;
}
.box>.formin>.info>span.bzcodep {
  margin-top: 7.066666vw;
}
.box>.formin>.info>input{
  margin-top: 4.1333vw;
  box-sizing: border-box;
  width: 90vw;
  height: 11.7333vw;
  background: #FFFFFF;
  border: 0.1333vw solid #2479D3;
  border-radius: 1.333333vw;
  padding-left: 2.933333vw;
  font-size: 3.7333vw;
  line-height: 11.7333vw;
  font-family: PingFang SC;
  font-weight: 500;
  color: #B3B3B3;
}
.box>.formin>.info>input.inq{
  margin-top: 5.73333vw;
  width: 90vw;
  height: 11.7333vw;
  background: #347CE4;
  border: 0.1333vw solid #F3F7FC;
  border-radius: 1.333333vw;
  font-size: 4.8vw;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 11.7333vw;
}
.box>.copyright {
  position: relative;
  margin-top: 18.53333vw;
  width: 93.6vw;
  text-align: center;
  height: 2.666666vw;
  font-size: 2.666666vw;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 2.666666vw;
}
.fade-enter-active,.fade-leave-active{
  transition: opacity .5s;
}
.fade-enter,.fade-leave-active {
  opacity:0;
}
</style>
